import { render, staticRenderFns } from "./PriceAvg.vue?vue&type=template&id=18cf4393&"
import script from "./PriceAvg.vue?vue&type=script&lang=js&"
export * from "./PriceAvg.vue?vue&type=script&lang=js&"
import style0 from "./PriceAvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports